export const ENABLE_WHEEL_DATE_TIME_PICKER_KEY = 'ENABLE_WHEEL_DATE_TIME_PICKER';

export const DATETIME_PRESENTATION_DATE = 'date';
export const DATETIME_PRESENTATION_DATE_TIME = 'date-time';
export const DATETIME_HOST_HIDE_TIME_CLASS = 'class.hide-time';
export const DATETIME_DATE_ONLY_REGEX = /^(\d{4}-\d{2}-\d{2})$/;
export const DATETIME_DATE_TIME_REGEX =
    /^(\d{4}-\d{2}-\d{2})T(\d{2}):(\d{2})(?::\d{2}(?:\.\d+)?)?(?:Z|[+-]\d{2}:\d{2})?$/;
export const DATETIME_START_OF_DAY = '00:00';
export const DATETIME_END_OF_DAY = '23:59';
export const DATETIME_CSS_VAR_COLOR_STEP_150 = '--ion-color-step-150';
export const DATETIME_CSS_VAR_BACKGROUND = '--background';
export const DATETIME_CSS_VAR_BACKGROUND_RGB = '--background-rgb';
export const DATETIME_CONTRAST_BLACK = '#000000';
export const DATETIME_CONTRAST_BLACK_RGB = '0, 0, 0';
export const DATETIME_CONTRAST_YELLOW = '#ffff00';
export const DATETIME_CONTRAST_YELLOW_RGB = '255, 255, 0';
export const DATETIME_CONTRAST_COLUMN_STYLE_ATTRIBUTE = 'data-datetime-contrast-column-style';
export const DATETIME_CONTRAST_COLUMN_STYLE_SELECTOR = `style[${DATETIME_CONTRAST_COLUMN_STYLE_ATTRIBUTE}]`;
export const DATETIME_CONTRAST_COLUMN_STYLE_CSS = `
  :host(.picker-column-active) .picker-item.picker-item-active,
  .picker-item.picker-item-active,
  .picker-item-active {
    color: var(--ion-color-base, var(--contrast-yellow, #ffff00)) !important;
    font-weight: 700 !important;
  }
`;
export const DATETIME_CONTRAST_PICKER_STYLE_ATTRIBUTE = 'data-datetime-contrast-picker-style';
export const DATETIME_CONTRAST_PICKER_STYLE_SELECTOR = `style[${DATETIME_CONTRAST_PICKER_STYLE_ATTRIBUTE}]`;
export const DATETIME_CONTRAST_PICKER_STYLE_CSS = `
  .picker-before {
    background: linear-gradient(to bottom, rgba(0, 0, 0, 0.6) 0%, rgba(0, 0, 0, 0.18) 100%) !important;
  }
  .picker-after {
    background: linear-gradient(to top, rgba(0, 0, 0, 0.6) 0%, rgba(0, 0, 0, 0.18) 100%) !important;
  }
  .picker-highlight {
    background: transparent !important;
    border-top: 1px solid var(--contrast-yellow, #ffff00) !important;
    border-bottom: 1px solid var(--contrast-yellow, #ffff00) !important;
    border-radius: 0 !important;
    width: 100% !important;
  }
`;

export const DATETIME_WHEEL_PICKER_STYLE_ATTRIBUTE = 'data-datetime-wheel-picker-style';
export const DATETIME_WHEEL_PICKER_STYLE_SELECTOR = `style[${DATETIME_WHEEL_PICKER_STYLE_ATTRIBUTE}]`;
// Android WebView does not reliably apply the wheel highlight background via CSS vars,
// so the selected row background is forced inside Ionic's picker Shadow DOM.
export const DATETIME_WHEEL_PICKER_LIGHT_STYLE_CSS = `
  .picker-highlight {
    background: var(--wheel-highlight-background, #f2f4f7) !important;
    border-radius: 0.75rem !important;
  }
`;
export const DATETIME_WHEEL_PICKER_DARK_STYLE_CSS = `
  .picker-highlight {
    background: transparent !important;
    border-top: 1px solid var(--ion-color-primary, #ffff00) !important;
    border-bottom: 1px solid var(--ion-color-primary, #ffff00) !important;
    border-radius: 0 !important;
    width: 100% !important;
  }
`;

export const DATETIME_SHADOW_STYLE_ATTRIBUTE = 'data-datetime-shadow-style';
export const DATETIME_SHADOW_STYLE_SELECTOR = `style[${DATETIME_SHADOW_STYLE_ATTRIBUTE}]`;
// Wheel-based date-only mode is internally still rendered as date-time, so time columns are hidden via Shadow DOM CSS.
export const DATETIME_SHADOW_STYLE_CSS = `
  ion-picker-column-internal {
    display: none !important;
  }
  ion-picker-column-internal.date-column {
    display: block !important;
  }
  ion-picker-column-internal:focus,
  ion-picker-column-internal:focus-visible {
    background: transparent !important;
  }
`;

export const DATETIME_CONTRAST_SHADOW_STYLE_ATTRIBUTE = 'data-datetime-contrast-shadow-style';
export const DATETIME_CONTRAST_SHADOW_STYLE_SELECTOR = `style[${DATETIME_CONTRAST_SHADOW_STYLE_ATTRIBUTE}]`;
// Ionic does not expose contrast styles for wheel internals, so high-contrast colors are forced inside Shadow DOM.
export const DATETIME_CONTRAST_SHADOW_STYLE_CSS = `
  :host(.contrast-wheel) {
    --ion-color-step-150: #000000 !important;
    --background: #000000 !important;
    --background-rgb: 0, 0, 0 !important;
  }
  :host(.contrast-wheel) ion-picker-internal {
    --ion-color-step-150: #000000 !important;
    --background: #000000 !important;
    --background-rgb: 0, 0, 0 !important;
  }
  :host-context(.high-contrast) {
    --ion-color-step-150: #000000 !important;
    --background: #000000 !important;
    --background-rgb: 0, 0, 0 !important;
  }
  :host-context(.high-contrast) ion-picker-internal {
    --ion-color-step-150: #000000 !important;
    --background: #000000 !important;
    --background-rgb: 0, 0, 0 !important;
  }
`;
